import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})
export class OperatorError 
{
    constructor(private _notifier : NotifierManager) {}

    invalidLoginId()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.OPERATOR_INVALID_LOGIN_ID)
    }
}